import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import JSON translations
import translationEN from "./locales/en/translation.json";
import translationID from "./locales/id/translation.json";

// Custom language detection
const getInitialLanguage = () => {
  const savedLang = localStorage.getItem("lang");
  if (savedLang) return savedLang;

  const browserLang = navigator.language || navigator.userLanguage;
  const initialLang = browserLang.startsWith("id") ? "id" : "en";
  localStorage.setItem("lang", initialLang);
  return initialLang;
};

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(), // ✅ Use custom logic
  fallbackLng: "en",
  resources: {
    en: { translation: translationEN },
    id: { translation: translationID },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
